/* lua.js generated code 0.3.0 */
var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")

var MonthTicketPanel = xClass("MonthTicketPanel", BasePanel, function () {
    return cc.Node.create()
})
MonthTicketPanel.resource = [
    "packed/MonthTicketMain.pack",
    "font/zzgftongxin_40.fnt",

]
const MonthTicketManager = require("./MonthTicketManager");


MonthTicketPanel.show = function (closeCb,successCb,entry) {
    function onSuccess() {
        MonthTicketPanel.create(entry,closeCb);
        successCb && successCb()
    }
    preloadWithLoading(MonthTicketPanel.resource, onSuccess, function () {
        Toast.make(getText("error.tip.load_res_error"))
        closeCb && closeCb()
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        closeCb && closeCb()
    })
}
MonthTicketPanel.prototype.ctor = function (entry,closeCb) {
    var self = this;
    // console.log("adstart adreward", adStartReward)
    BasePanel.prototype.ctor.call(self)
    this.mgr = MonthTicketManager.getInstance();
    this.mgr.dcPageShow(entry)
    self.entry = entry;
    self.closeCb = closeCb

    this.mgr.mainPanel = self;
    this.mgr.setOpenLastTime()
    self.fitScreen()

    self.session = DCAssist.dc4ShowCashGoods(ModuleName.MONTH_TICK, self.entry ? self.entry : "main", this.mgr.getGoodsIds([MonthTicketConst.equity, MonthTicketConst.res, MonthTicketConst.pack]))
    self.initUI()
    // self.popup(null,null,null,null,null,250);
    self.popup()
}

MonthTicketPanel.prototype.initUI = function () {
    let self = this;

    self.mainNode = cc.CSLoader.createNode("cocos/ticket_ticket_main.csb")
    self.addChild(self.mainNode);

    let closeBtn = UIButton.create(self.mainNode.getChildByName("com_close"));
    PushBounceAnim.create(closeBtn)
    closeBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.onClose()
    })

    self.resTicketNode = self.mainNode.getChildByName("orange")
    self.equityTicketNode = self.mainNode.getChildByName("blue")
    self.packTickeNode = self.mainNode.getChildByName("banner")
    // 资源卡显示
    self.resBuyBtn = UIButton.create(self.resTicketNode.getChildByName("btn_buy"));
    PushBounceAnim.create(self.resBuyBtn)
    self.resBuyBtn.on(UIButtonEvent.Click, () => {

        self.buy(MonthTicketConst.res)
    })

    self.resHelpBtn = UIButton.create(self.resTicketNode.getChildByName("btn_help"));
    PushBounceAnim.create(self.resHelpBtn)
    self.resHelpBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.mgr.dcMonthTicketNormal("page_click", self.mgr.getDCSession(), {
            click_type: "profit_note"
        })

        ActivityCommon.showExplain(() => {
            self.isBusy = false
            self.mgr.dcMonthTicketNormal("profit_note_show")
        }, {
            text: getText("monthcard.illustrate.text2"),
            title: "说明",
        })

    })


    self.resReceiveBtn = UIButton.create(self.resTicketNode.getChildByName("btn_receive"));
    PushBounceAnim.create(self.resReceiveBtn)
    self.resReceiveBtn.on(UIButtonEvent.Click, () => {
        self.mgr.dcMonthTicketNormal("page_click", self.mgr.getDCSession(), {
            click_type: "profit_get"
        })

        self.receiveDailyReward()
    })

    self.initResTicketRewardsUI()

    // 权益卡显示
    self.equityBuyBtn = UIButton.create(self.equityTicketNode.getChildByName("btn_buy"));
    PushBounceAnim.create(self.equityBuyBtn)
    self.equityBuyBtn.on(UIButtonEvent.Click, () => {
        // let product = MetaManager.getProductMetaByID(76)
        // cc.log("MonthTicket  product ",product)

        // let good = MetaManager.getInstance().getGoodsMeta(product.goodsId)
        // cc.log("MonthTicket  good ",good,good.getRmb())
    
        // let productId = self.mgr.getProductId(MonthTicketConst.equity)
        self.buy(MonthTicketConst.equity)
    })

    self.equityHelpBtn = UIButton.create(self.equityTicketNode.getChildByName("btn_help"));
    PushBounceAnim.create(self.equityHelpBtn)
    self.equityHelpBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.mgr.dcMonthTicketNormal("page_click", self.mgr.getDCSession(), {
            click_type: "privilege_note"
        })
        ActivityCommon.showExplain(() => {
            self.isBusy = false
            self.mgr.dcMonthTicketNormal("privilege_note_show")
        }, {
            text: getText("monthcard.illustrate.text1"),
            title: "说明"
        })
    })


    let equityRewardNode = self.equityTicketNode.getChildByName("ticket_iconbg_blue")
    // let equityReward = {
    //     itemId: 14,
    //     num: 10
    // }

    let equityGood = self.mgr.getGoodMeta(MonthTicketConst.equity)
    self.initRewardUI(equityRewardNode, equityGood.items[1])
    self.equityBuyBtn.getChildByName("label").setString(`￥${equityGood.getRmb()/100}购买`)
    TTUtil.addTTIcon(self.equityBuyBtn.getChildByName("label"), equityGood.getRmb()/100,{
        format: "{price}购买",
        icon_scale: 1.5
    })


    // 打包购买显示
    self.packBuyBtn = UIButton.create(self.packTickeNode.getChildByName("btn_buy"));
    PushBounceAnim.create(self.packBuyBtn)
    self.packBuyBtn.on(UIButtonEvent.Click, () => {

        // let productId = self.mgr.getProductId(MonthTicketConst.pack)
        self.buy(MonthTicketConst.pack)
    })


    self.packTryBtn = UIButton.create(self.packTickeNode.getChildByName("btn_receive"));
    PushBounceAnim.create(self.packTryBtn)
    self.packTryBtn.on(UIButtonEvent.Click, () => {
        if (self.isBusy) {
            return
        }
        self.isBusy = true
        self.mgr.dcMonthTicketNormal("page_click", self.mgr.getDCSession(), {
            click_type: "trial_buy"
        })
        self.mgr.showTryPanel(() => {
            self.isBusy = false
            self.updateUI()
        },self.entry)
    })
    let packGood = self.mgr.getGoodMeta(MonthTicketConst.pack)
    self.packBuyBtn.getChildByName("label").setString(`￥${packGood.getRmb()/100}购买`)
    TTUtil.addTTIcon(self.packBuyBtn.getChildByName("label"), packGood.getRmb()/100,{
        format: "{price}购买",
        icon_scale: 1.5
    })

    self.updateUI()

    // 动画
    let downLight = cc.CSLoader.createNode("cocos/month_ticket_anim_wjbz_diabn.csb")
    downLight.anim = cc.CSLoader.createTimeline("cocos/month_ticket_anim_wjbz_diabn.csb")
    downLight.runAction(downLight.anim)
    downLight.anim.gotoFrameAndPlay(0, true)
    downLight.setLocalZOrder(10)
    self.packTickeNode.getChildByName("ticket_banner").addChild(downLight)
    // 
    let tryLight = cc.CSLoader.createNode("cocos/month_ticket_anim_ylyp_button.csb")
    tryLight.anim = cc.CSLoader.createTimeline("cocos/month_ticket_anim_ylyp_button.csb")
    tryLight.runAction(tryLight.anim)
    tryLight.anim.gotoFrameAndPlay(0, true)
    self.packTryBtn.addChild(tryLight)
    SpriteUtil.findBlendChilds_AddOneOne(tryLight, true)
    tryLight.x = 2

    self.playTopAnim("idle")

    const Event = require("hecore/EventDispatcher").Event;
    GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterPanel,
        {
            id: WelfareCenterId.monthTicket,
        }))
    //
    if (MonthTicketManager.getInstance().isClose()) {
        let textTip = cc.LabelTTF.create(getText("month.ticket.close.tip2"), null, 24, 550, cc.TEXT_ALIGNMENT_CENTER);
        textTip.setColor(cc.c4b(237, 231, 217, 255));
        textTip.setDimensions(550, 0);
        textTip.setLineHeight(30);
        self.mainNode.addChild(textTip);
        textTip.y = self.packTickeNode.y - 137;
    }
}
MonthTicketPanel.prototype.updateUI = function () {
    let self = this
    let isCanExperience = self.mgr.isCanExperienceTicket()
    self.packTryBtn.setVisible(isCanExperience)
    if (!isCanExperience) {
        self.packBuyBtn.y = 0
    }

    // 时间
    let equityTimeNode = self.equityTicketNode.getChildByName("time_node")
    let equityEndTs = self.mgr.getEquityEndTs()
    let resTimeNode = self.resTicketNode.getChildByName("time_node")
    let resndTs = self.mgr.getResourceEndTs()
    let timeCur = Localhost.time()
    let updateTime = (node, endTs) => {
        if (!endTs || endTs < timeCur) {
            node.setVisible(false)
        } else {
            node.setVisible(true)
            let num = self.mgr.getRemainderDay(endTs)
            node.getChildByName("label_num").setString(num)
        }
    }
    updateTime(equityTimeNode, equityEndTs)
    updateTime(resTimeNode, resndTs)
    if (UserManager.getInstance().isHaveResourceMonthTicket()) {
        // 已领取更新按钮状态
        let isCanReceive = self.mgr.getResourceRewards()
        self.resReceiveBtn.getChildByName("normal").setVisible(isCanReceive)
        self.resReceiveBtn.getChildByName("discard").setVisible(!isCanReceive)
        self.resReceiveBtn.setEnabled(isCanReceive)

        self.resReceiveBtn.setVisible(true)
    } else {
        self.resReceiveBtn.setVisible(false)
    }


    // 支付被关闭 特殊处理
    let supportCash = MetaManager.isSupportCash()

    self.mainNode.getChildByName("banner").setVisible(supportCash)
    self.equityBuyBtn.setVisible(supportCash)
    self.resBuyBtn.setVisible(supportCash)

}
MonthTicketPanel.prototype.buy = function (type) {
    let self = this;
    if (self.isBusy) return
    self.isBusy = true
    self.playTopAnim("show")
    let click_type = ""
    if (type == MonthTicketConst.equity){
        click_type = "privilege_buy"
    }else if (type == MonthTicketConst.res){
        click_type = "profit_buy"
    }else{
        click_type = "combo_buy"
    }
    self.mgr.dcMonthTicketNormal("page_click", self.mgr.getDCSession(), {
        click_type: click_type
    })

    function onSuccess(payData) {
        self.isBusy = false
        // self.mgr.info.privilegeEndTs =  1708531200000
        self.updateUI()
    }

    function onFail(evt) {
        self.isBusy = false
    }
    self.mgr.buy(type, onSuccess, onFail, onFail, ModuleName.MONTH_TICK, {
        session: self.session,
        scence: ModuleName.MONTH_TICK,
        entry: self.entry ? self.entry : "main"
    })

}
// 领取每日
MonthTicketPanel.prototype.receiveDailyReward = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    self.playTopAnim("show")
    self.mgr.fetchRewardHttp(1).then(() => {
        self.isBusy = false
        // let dailyRewards =  self.mgr.getDailyRewards()
        self.updateUI()

    }).catch((evt) => {
        self.isBusy = false
    })

}


MonthTicketPanel.prototype.initRewardUI = function (node, reward) {
    let icon = UIItemBuilder.createProp(reward.itemId, reward.num, null, true, true)[0]
    icon.scale = 0.6
    node.getChildByName("icon").addChild(icon)
    let label = node.getChildByName("label")
    label.y = 12
    label.setString("x" + reward.num)
}
MonthTicketPanel.prototype.initResTicketRewardsUI = function () {
    let self = this
    let dailyRewards = self.mgr.getDailyRewards()

    for (let i = 0; i < 4; i++) {
        let node = self.resTicketNode.getChildByName("ticket_iconbg_org" + (i + 1))
        let reward = dailyRewards[i]
        node.setVisible(reward)
        if (reward) {
            self.initRewardUI(node, reward)
        }


    }



    let resRewardNode = self.resTicketNode.getChildByName("ticket_iconbg_org5")
    // let resReward = {
    //     itemId: 14,
    //     num: 10
    // }
    let resGood = self.mgr.getGoodMeta(MonthTicketConst.res)
    self.initRewardUI(resRewardNode, resGood.items[1])
    self.resBuyBtn.getChildByName("label").setString(`￥${resGood.getRmb()/100}购买`)
    TTUtil.addTTIcon(self.resBuyBtn.getChildByName("label"), resGood.getRmb()/100,{
        format: "{price}购买",
        icon_scale: 1.5
    })
}
// 播放顶部动画
MonthTicketPanel.prototype.playTopAnim = function (name) {
    cc.log("MonthTicket playTopAnim ", name)
    if (!this.topAnimNode) {
        this.topAnimNode = sp.SkeletonAnimation.create("spine/ylyp_captain.skel", "spine/ylyp_captain.atlas", 1)
        this.mainNode.getChildByName("title").addChild(this.topAnimNode)
        this.topAnimNode.setPosition(-250, 50)
    }
    this.topAnimNode.setAnimation(0, name, false)
    this.topAnimNode.registerSpineEventHandler((trackIndex) => {
        this.topAnimNode.setAnimation(0, "idle", true)
        this.topAnimNode.unregisterSpineEventHandler(sp.ANIMATION_EVENT_TYPE.COMPLETE)

    }, sp.ANIMATION_EVENT_TYPE.COMPLETE)
}

MonthTicketPanel.prototype.onClose = function (cb) {
    let self = this;
    this.mgr.mainPanel = null;
    self.closeCb && self.closeCb()
    BasePanel.prototype.onClose.call(self, cb);

}
MonthTicketPanel.prototype.onCleanup = function () {
    let self = this;
    ResManager.release(MonthTicketPanel.resource)
}
/**
 * UI适配屏幕分辨率
 */
MonthTicketPanel.prototype.fitScreen = function () {
    var self = this
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width


    var scale = Math.min(scaleX, scaleY)
    cc.log("fitScreen", scale)
    self._scale = scale
    self.setScale(self._scale)


}
module.exports = MonthTicketPanel